var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0028 15.2756C16.112 15.2756 17.8219 13.5658 17.8219 11.4565C17.8219 9.34723 16.112 7.63733 14.0028 7.63733C11.8935 7.63733 10.1836 9.34723 10.1836 11.4565C10.1836 13.5658 11.8935 15.2756 14.0028 15.2756Z",
    fill: "url(#paint0_linear_622_3052)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5027 3.81862H20.9824C20.8034 3.81862 20.5815 3.70287 20.4084 3.52029L18.8607 1.07757C18.8362 1.0388 18.8089 1.0019 18.779 0.967184C18.2444 0.343676 17.5218 0 16.7461 0H11.2569C10.4812 0 9.75867 0.343676 9.22406 0.967184C9.19412 1.0019 9.1668 1.0388 9.14232 1.07757L7.59459 3.52387C7.46213 3.66826 7.27597 3.8222 7.08027 3.8222V3.34487C7.08027 3.09168 6.97969 2.84886 6.80066 2.66983C6.62162 2.4908 6.3788 2.39022 6.12561 2.39022H4.69363C4.44044 2.39022 4.19762 2.4908 4.01859 2.66983C3.83956 2.84886 3.73898 3.09168 3.73898 3.34487V3.8222H3.50032C2.74099 3.82299 2.01299 4.12498 1.47606 4.66191C0.939134 5.19883 0.637142 5.92683 0.636353 6.68616V18.1384C0.637142 18.8978 0.939134 19.6258 1.47606 20.1627C2.01299 20.6996 2.74099 21.0016 3.50032 21.0024H24.5027C25.262 21.0016 25.99 20.6996 26.527 20.1627C27.0639 19.6258 27.3659 18.8978 27.3667 18.1384V6.68258C27.3659 5.92325 27.0639 5.19525 26.527 4.65833C25.99 4.1214 25.262 3.81941 24.5027 3.81862ZM14.0015 17.1838C12.8686 17.1838 11.7612 16.8478 10.8192 16.2185C9.87729 15.5891 9.14313 14.6945 8.7096 13.6478C8.27607 12.6012 8.16263 11.4495 8.38365 10.3384C8.60466 9.22728 9.15019 8.20666 9.95126 7.4056C10.7523 6.60453 11.7729 6.059 12.884 5.83799C13.9952 5.61697 15.1469 5.73041 16.1935 6.16394C17.2401 6.59747 18.1347 7.33163 18.7641 8.27359C19.3935 9.21554 19.7294 10.323 19.7294 11.4559C19.7277 12.9745 19.1237 14.4304 18.0498 15.5042C16.976 16.578 15.5201 17.182 14.0015 17.1838V17.1838Z",
    fill: "url(#paint1_linear_622_3052)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_622_3052",
    x1: 10.1836,
    y1: 11.4565,
    x2: 17.8219,
    y2: 11.4565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_622_3052",
    x1: 0.636353,
    y1: 10.5012,
    x2: 27.3667,
    y2: 10.5012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#406EE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#406EE2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.99d5dd1c22e25638fcf3b1b7ee280ec2.svg";
export { ForwardRef as ReactComponent };